<template>
    <div class="about">
        <Inbanner />
        <div class="container">
            <el-breadcrumb separator="/" style="margin:20px 0;">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>新闻</el-breadcrumb-item>
                <el-breadcrumb-item>{{newstitle}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <h3 class="text-center">{{newstitle}}</h3>
                    <div class="text-center">
                        <span class="" style="margin-right:50px;"><i class="iconfont">&#xe9bd;</i> 仁迅科技</span> 
                        <span class=""><i class="iconfont">&#xe9bd;</i> {{newstime}}</span> 
                    </div>
                </div>
                <div class="news-content">
                    <p style="text-indent:2em;">2021年3月28日， 上海仁迅科技旗下iTrial Genies智能数字化临床研究平台产品目录又添新成员：iTrial Genies VMS。此次iTrial Genies产品版本号为V2.7.0。</p>                
                    <p style="text-indent:2em;">iTrial Genies VMS即可视化管理系统，从多维度的视角，贯穿整个临床研究关键领域的数字化信息，通过智慧看板的方式进行从宏观到微观的无死角的数据可视化呈现。炫酷且实用的大屏展示，为申办方把控项目整体状况、项目管理者日常监督管理项目提供了绝佳的视角，无需深入平台功能细节即可掌控全局。</p>
                    <el-row :gutter="20" class="new-img-3">
                        <el-col :span="12">
                            <img src="@/assets/img/news/news_2_1.jpg">
                        </el-col>
                        <el-col :span="12">
                            <img src="@/assets/img/news/news_2_2.jpg">
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="new-img-2">
                        <el-col :span="12">
                            <div class="text-center">
                                <h4>自上而下、多维度的可视化看板</h4>
                                <p>从总览、项目、中心及受试者四个维度逐层可视化展示相关数据</p>
                                <p>汇聚SDC, EDC, CCM及DCS多个平台数据进行准实时的展示</p>
                                <img src="@/assets/img/news/news_2_3.jpg">
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="text-center">
                                <h4>所有项目的核心指标实时统计图表</h4>
                                <p>汇总统计所有项目的状态分布</p>
                                <p>轮播展示各项目的任务进度、入组情况、问题统计以及工时投入情况</p>
                                <img src="@/assets/img/news/news_2_4.jpg">
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="new-img-2">
                        <el-col :span="12">
                            <div class="text-center">
                                <h4>项目核心指标、里程碑进度以及各中心数据</h4>
                                <p>指定项目的核心指标，里程碑进度、入组趋势、风险问题及工时统计，自由切换到指定项目</p>
                                <p>各中心关键指标仪表盘（任务指标、里程碑节点、入组进度、风险和工时）</p>
                                <img src="@/assets/img/news/news_2_5.jpg">
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="text-center">
                                <h4>中心层面核心指标、里程碑进度以及受试者数据一览</h4>
                                <p>可视化展示指定项目的核心指标，里程碑进度、入组趋势、风险问题及工时统计</p>
                                <p>各中心关键指标仪表盘，可按中心进行自由切换视图</p>
                                <img src="@/assets/img/news/news_2_6.jpg">
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-card>
        </div>
    </div>
</template>
<script>
import Inbanner from './pages/Inbanner'
export default{
    data() {
        return {
            newstitle: 'iTrial Genies VMS盛大发布',
            newstime: '2020.10.16',
        };
    },
    components:{
        Inbanner
    }
}
</script>
<style >
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
h2 {
    font-size: 22px;
    margin: 30px 0;
    font-weight: 700;
}
.news-content img{
    max-width:100%;
}
.news-content p{
    margin-bottom: 15px;
}
</style>